import React from 'react';
import { BookOpen, ArrowRight } from 'lucide-react';
import AdSpace from '../components/AdSpace';
import { useSetMeta } from '../hooks/useSetMeta';
import blogIndexData from '../src/content/blog-index.json';

export const ARTICLES = [
  {
    slug: 'what-is-saturn-return',
    title: "What Is a Saturn Return? A Complete Guide to Your Cosmic Coming of Age",
    excerpt: "Demystifying the astrological milestone that happens in your late twenties and forces you to confront the foundations of your adulthood.",
    category: "Astrology",
    date: "March 20, 2026"
  },
  {
    slug: 'zodiac-compatibility-guide',
    title: "The Truth About Zodiac Compatibility: Beyond the Sun Sign",
    excerpt: "Why limiting relationship analysis to just Sun signs is flawed, and how moon signs and Venus placements determine true synastry.",
    category: "Astrology",
    date: "March 21, 2026"
  },
  {
    slug: 'how-to-read-tarot-for-beginners',
    title: "How to Read Tarot for Beginners: A Practical Guide",
    excerpt: "A structured, non-dogmatic approach to understanding the Fool's Journey and unlocking the psychological power of the Major Arcana.",
    category: "Tarot",
    date: "March 22, 2026"
  },
  {
    slug: 'chinese-zodiac-2025',
    title: "2025: The Year of the Wood Snake",
    excerpt: "What the transition from the roaring Wood Dragon to the cunning Wood Snake means for global trends and your personal growth.",
    category: "Chinese Zodiac",
    date: "March 23, 2026"
  },
  {
    slug: 'age-calculator-uses',
    title: "Chronological vs. Cosmic Time: Why Your Exact Age Matters",
    excerpt: "From stoic philosophy to precise astrological transits, exploring the profound psychological impact of tracking the passage of time.",
    category: "Wellness",
    date: "March 24, 2026"
  }
];

const BlogIndex: React.FC = () => {
  // Set SEO meta tags for this page
  useSetMeta({
    title: 'ZodiAge Blog - Astrology, Zodiac & Tarot Articles | ZodiAge',
    description: 'Read our in-depth blog articles about astrology, zodiac compatibility, tarot reading, Chinese zodiac, and cosmic insights.',
    ogImage: 'https://zodiage.com/logo.png'
  });
    return (
        <div className="max-w-5xl mx-auto py-12 px-4 animate-in fade-in duration-700">
            <div className="text-center mb-16">
                <div className="bg-gradient-to-r from-purple-600/20 to-pink-500/20 p-4 rounded-full w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                    <BookOpen className="text-purple-400" size={40} />
                </div>
                <h1 className="text-4xl md:text-5xl font-display font-bold text-white mb-4">
                    The ZodiAge Journal
                </h1>
                <div className="max-w-2xl mx-auto text-gray-400 text-lg leading-relaxed">
                    <div className="seo-content" dangerouslySetInnerHTML={{ __html: blogIndexData.html }} />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {ARTICLES.map((article) => (
                    <button
                        key={article.slug}
                        onClick={() => { window.history.pushState({}, '', `/blog/${article.slug}`); window.dispatchEvent(new PopStateEvent('popstate')); }}
                        className="bg-card/50 border border-gray-800 rounded-2xl p-6 text-left hover:border-purple-500/50 hover:bg-card/80 transition-all group flex flex-col min-h-[300px]"
                    >
                        <div className="mb-4 flex justify-between items-center text-xs">
                            <span className="text-secondary font-bold uppercase tracking-wider">{article.category}</span>
                            <span className="text-gray-500">{article.date}</span>
                        </div>
                        <h2 className="text-2xl font-bold text-white mb-3 group-hover:text-purple-400 transition-colors leading-tight">
                            {article.title}
                        </h2>
                        <p className="text-gray-400 text-sm leading-relaxed mb-6 flex-1">
                            {article.excerpt}
                        </p>
                        <div className="flex items-center text-sm font-bold text-white group-hover:text-pink-400 transition-colors mt-auto">
                            Read Article <ArrowRight size={16} className="ml-2 group-hover:translate-x-1 transition-transform" />
                        </div>
                    </button>
                ))}
            </div>
            
            <AdSpace type="multiplex" slot="9466105368" className="mt-16" />
        </div>
    );
};

export default BlogIndex;
